<div class="contenedor-filtros p-16">
    <h2 class="m-0">Regiones</h2>
    <mat-divider></mat-divider>
    <br />

    <div
        fxLayoutGap="30px"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-around center"
    >
        <mat-form-field class="full-width">
            <mat-label>Regiones</mat-label>
            <mat-select required (selectionChange)="buscarComunas($event)">
                <mat-option *ngFor="let region of regiones" [value]="region.id">
                    {{ region.nombre }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
